<template>
  <div :class="{ 'report-header-wrapper': $route.name === 'report' }">
    <header
      v-if="$route.name"
      class="header-wrapper"
      :class="{
        'header-wrapper-with-banner': withBanner,
        'header-wrapper-with-subscription-banner': getSubscriptionBannerState,
      }"
    >
      <div
        v-if="$route.name === 'landing-page'"
        class="header"
      >
        <div>
          <SatoshiEyeLogo
            class="header-logo pointer"
            @click="$router.push({ name: 'source-of-funds' })"
          />
        </div>
        <div class="flex-1 flex flex-end m-display-none">
          <div
            class="flex-1 flex align-center space-between bold gap-4 max-w-600 fs-18 t-fs-14"
          >
            <div
              class="pointer"
              @click="
                scrollToSelectorItem('.main', '.landing-page-features-wrapper')
              "
            >
              Features
            </div>
            <div
              class="pointer"
              @click="
                scrollToSelectorItem(
                  '.main',
                  '.landing-page-pricing__for-background',
                )
              "
            >
              Pricing
            </div>
            <div
              class="pointer"
              @click="scrollToSelectorItem('.main', '.landing-page-faq-wrapper')"
            >
              FAQ
            </div>
            <div
              v-if="!isLogin"
              class="pointer"
              @click="$router.push('/login')"
            >
              Log In
            </div>
            <router-link
              class="header__button-get-report"
              :to="'/source-of-funds'"
            >
              Get Report
            </router-link>
          </div>
        </div>
        <div class="display-none m-flex m-flex-end m-fullwidth">
          <div>
            <transition-group name="fade-leave">
              <gl-icon
                v-if="showLandingMenu"
                key="close"
                class="mr-2 pointer"
                :height="24"
                name="close"
                :width="24"
                @click="closeFooterLandingMenu"
              />
              <gl-icon
                v-else
                key="mobile-menu"
                class="mr-2 pointer"
                :height="34"
                name="mobile-menu"
                :width="34"
                @click="openFooterLandingMenu"
              />
            </transition-group>
          </div>
        </div>
      </div>
      <div
        v-else
        class="header header-main gap-4"
      >
        <div class="flex align-center space-between wrap">
          <!-- <div
            v-if="isMobile && $route.name === 'report'"
            class="header-back-arrow-wrapper bold accent-text-link pointer"
            @click="$router.push({ name: 'source-of-funds' })"
          >
            <gl-icon
              class="mr-2"
              :height="18"
              name="arrow-back"
              :width="11"
            />
            <div> Back to <span class="bold-700">Source of Funds</span> </div>
          </div> -->
          <div>
            <SatoshiEyeLogo
              v-if="isMobileNew"
              class="header-logo-main"
              @click="$router.push({ name: 'source-of-funds' })"
            />
            <SatoshiEyeLogoOnly
              v-else
              class="header-logo-main"
              @click="$router.push({ name: 'source-of-funds' })"
            />
          </div>
          <div
            v-if="!isMobile"
            class="flex-1 flex align-center space-around gap-4 pointer bold"
          >
            <!-- <div class="ml-4">
              <router-link
                class="header__nav-link"
                :to="{ name: 'source-of-funds' }"
              >
                Source of funds
              </router-link>
            </div> -->
            <!-- <div class="ml-4">
              <router-link
                class="header__nav-link header__nav-link-disabled"
                :to="{ name: 'landing-page' }"
              >
                Destination of funds
              </router-link>
            </div> -->

            <!-- <div> Destination of funds </div> -->
          </div>
        </div>

        <div class="flex-1 flex align-center flex-end gap-4">
          <!-- <div
            v-if="userEmail && (!isMobile || $route.name !== 'payment')"
            class="header__lookups"
            :class="{ 'header__lookups-nolink': isB2bUser}"
            @click="onLookupClick"
          >
            <gl-icon
              :class="{ pointer: !isB2bUser}"
              :height="28"
              name="lookups-blue-new"
              :width="28"
            />
            <GlActionLink
              :link-text="
                isMobile
                  ? `${userData.balance || 0}`
                  : `${userData.balance || 0} Lookups`
              "
            />
          </div> -->
          <div
            v-if="userEmail"
            class="header-chips-wrapper"
          >
            <GlStatusChip
              v-if="isLimitShown"
              class="pointer"
              type="info"
              @click="onLimitClick"
            >
              <template #icon>
                <gl-icon
                  :failure="!getCurrentPlan?.reportsRemaining"
                  :height="20"
                  name="I-S-Info-Fill"
                  :warning="!!getCurrentPlan?.reportsRemaining"
                  :width="20"
                />
              </template>
              {{ getCurrentPlan?.reportsRemaining }} <span v-if="!isMobile">Reports </span>Left
            </GlStatusChip>
            <GlStatusChip
              v-if="currentPlanLabel"
              class="pointer"
              :type="isFreePlan ? 'info' : 'brand'"
              @click="onPlanClick"
            >
              <template
                v-if="!isFreePlan"
                #icon
              >
                <gl-icon
                  brand
                  :height="20"
                  name="I-S-Upgrade Plan"
                  :width="20"
                />
              </template>
              {{ currentPlanLabel }}
            </GlStatusChip>
          </div>
          <div
            v-if="isMobileDevice() && !isPWAInstalled()"
            class="flex align-center"
            @click="installHandler"
          >
            <gl-icon
              class="pointer"
              :height="24"
              name="pwa-install"
              :width="24"
            />
          </div>
          <div
            v-if="userEmail"
            class="flex align-center"
          >
            <div
              v-if="isMobile || isTablet"
              @click="$emit('avatar-click')"
            >
              <Avatar
                :label="userFirstLetter"
                shape="circle"
              />
            </div>
            <gl-menu-dropdown
              v-else
              close-on-click-item
            >
              <template #label>
                <Avatar
                  :label="userFirstLetter"
                  shape="circle"
                />
              </template>
              <router-link
                class="flex align-center main-text py-2"
                :to="{name: 'source-of-funds'}"
              >
                <gl-icon
                  class="mr-2"
                  :height="24"
                  name="your-reports"
                  :width="24"
                />
                Reports
              </router-link>
              <router-link
                v-if="isAdmin"
                class="flex align-center main-text py-2"
                :to="{name: 'admin-panel'}"
              >
                <gl-icon
                  class="mr-2"
                  :height="24"
                  name="your-reports"
                  :width="24"
                />
                Admin panel
              </router-link>
              <router-link
                class="flex align-center main-text py-2"
                :to="{name: 'profile'}"
              >
                <gl-icon
                  class="mr-2"
                  :height="24"
                  name="unknown-user-transparent"
                  :width="24"
                />
                Profile Information
              </router-link>

              <router-link
                class="flex align-center main-text py-2"
                :to="{name: 'landing-page', params: { section: '.nlp__faq' }}"
              >
                <gl-icon
                  class="mr-2"
                  :height="24"
                  name="I-Question"
                  :width="24"
                />
                FAQ
              </router-link>

              <div
                class="flex align-center py-2"
                @click="contactSupport"
              >
                <gl-icon
                  class="mr-2"
                  :height="24"
                  name="get-help-dark"
                  :width="24"
                />
                Get help?
              </div>

              <div
                v-if="!isB2bUser"
                class="flex align-center py-2"
                @click="logoutUser"
              >
                <gl-icon
                  class="mr-2"
                  :height="24"
                  name="logout"
                  :width="24"
                />
                Log Out
              </div>
            </gl-menu-dropdown>
          </div>
          <div v-else>
            <div
              v-if="!isLogin"
              id="login-button"
              class="flex align-center gap-1 pointer fs-14 bold"
              @click="$router.push('/login')"
            >
              <gl-icon
                class="mr-2"
                gray
                :height="24"
                name="I-LogIn"
                :width="24"
              />
              Log In / Sign Up
            </div>
          </div>

          <div
            v-if="!isDesktop && $route.name === 'payment'"
            class="header-back-arrow-wrapper bold accent-text-link pointer"
            @click="SET_IS_PAYMENT_HISTORY_OPEN(!isPaymentHistoryOpen)"
          >
            <transition-group name="fade-leave">
              <gl-icon
                v-if="!isPaymentHistoryOpen"
                key="history-time"
                class="mr-2"
                :height="29"
                name="history-time"
                :width="29"
              />
              <gl-icon
                v-else
                key="close"
                class="mr-2"
                :height="24"
                name="close"
                :width="24"
              />
            </transition-group>
          </div>

          <!-- <div
            v-else
            class="flex pointer"
            @click="contactSupport"
          >
            <gl-icon
              class="mr-2"
              dark
              :height="isMobile ? 30 : 24"
              name="get-help"
              :width="isMobile ? 30 : 24"
            />
            <GlActionLink
              v-if="!isMobile"
              class="mr-2"
              link-text="Get help?"
            />
          </div> -->
        </div>
      </div>
      <SubscriptionBanner
        v-if="showSubscriptionBanner"
      />
    </header>
    <GlHeaderReport v-if="$route.name === 'report'" />
  </div>
</template>

<script>
// Components
import GlIcon from '@/components/gl-icon'
import SatoshiEyeLogo from '@/assets/svg/header/SatoshiEyeLogo.svg?inline'
import SubscriptionBanner from '@/components/layout/SubscriptionBanner.vue'
import SatoshiEyeLogoOnly from '@/assets/svg/header/SatoshiEyeLogoOnly.svg?inline'
import GlActionLink from '@/components/gl-action-link'
import GlMenuDropdown from '@/components/gl-menu-dropdown'
import Avatar from 'primevue/avatar'
import GlHeaderReport from '@/components/layout/gl-header-report.vue'
import GlStatusChip from '@/components/badges/gl-status-chip'
import LimitsReachedModal from '@/pages/report/components/purchase/modals/LimitsReachedModal'
// Vuex
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
// Utils
import { scrollToSelector } from '@/utils/scroll-to'
import { contactSatoshieyeSupport } from '@/utils/go-to-route'
import {checkIfIos, installPWA, isMobileDevice, isPWAInstalled, shouldSkipPWAInstallCheck} from "@/utils/pwa-support";
//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  components: {
    GlIcon,
    GlActionLink,
    SatoshiEyeLogo,
    SatoshiEyeLogoOnly,
    GlMenuDropdown,
    Avatar,
    GlHeaderReport,
    GlStatusChip,
    SubscriptionBanner,
  },
  mixins: [deviceWidthMixin],
  props: {
    withBanner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPrompt: false,
      isIos: false,
      deferredPrompt: null,
      // availableToInstall: false,
    }
  },
  computed: {
    ...mapState('user', ['userData']),
    ...mapState('sidebar', ['showLandingMenu', 'isPaymentHistoryOpen', 'isPromptOpen']),
    ...mapGetters('user', ['isAdmin', 'isLogin', 'isB2bUser']),
    ...mapGetters('payment', ['getCurrentPlan', 'isFreePlan']),
    ...mapGetters('subscribe', ['getSubscriptionBannerState']),
    ...mapGetters('report', ['getIsLegacy']),
    headerHeight() {
      return getComputedStyle(document.documentElement).getPropertyValue(
        '--header-height',
      )
    },
    reportBannerHeight() {
      return getComputedStyle(document.documentElement).getPropertyValue(
        '--report-banner-height',
      )
    },
    userFirstLetter() {
      return this.userEmail && this.userEmail.charAt(0).toUpperCase()
    },
    userEmail() {
      return this.userData && this.userData.email
    },
    isLimitShown() {
      const { monthlyQuota, reportsRemaining } = this.getCurrentPlan || {};
      const isValidQuota = monthlyQuota !== undefined && monthlyQuota >= 0;
      return isValidQuota && reportsRemaining <= 5;
    },
    currentPlanLabel() {
      const planTier = this.getCurrentPlan?.planTier
      if (!planTier) return
      return `${planTier} ${this.isMobile ? '' : 'Plan'}`
    },
    showSubscriptionBanner() {
      return this.getSubscriptionBannerState && this.userEmail && !this.getIsLegacy
    },
  },
  watch: {
    $route() {
      this.closeFooterLandingMenu()
      this.SET_IS_PAYMENT_HISTORY_OPEN(false)
    },
    showSubscriptionBanner(newVal) {
      if (!newVal) return
      this.$root.$emit('handle-document-size')
    },
  },
  mounted() {
    this.checkAvailableToInstall()
  },
  beforeDestroy() {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    isPWAInstalled,
    isMobileDevice,
    checkIfIos,
    shouldSkipPWAInstallCheck,
    ...mapActions('user', ['logout']),
    ...mapMutations({
      SET_SHOW_LANDING_MENU: 'sidebar/SET_SHOW_LANDING_MENU',
      SET_IS_PAYMENT_HISTORY_OPEN: 'sidebar/SET_IS_PAYMENT_HISTORY_OPEN',
      SET_IS_PROMPT_OPEN: 'sidebar/SET_IS_PROMPT_OPEN',
    }),
    scrollToSelector,
    contactSatoshieyeSupport,
    checkAvailableToInstall() {
      // if (this.shouldSkipPWAInstallCheck()) return

      // this.availableToInstall = true

      if (!this.checkIfIos()) {
        window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
      }
    }
    ,
    installHandler() {
      this.SET_IS_PROMPT_OPEN(true)
      // if (this.checkIfIos()) {
      //   this.SET_IS_PROMPT_OPEN(true)
      // } else {
      //   this.SET_IS_PROMPT_OPEN(false)
      //   this.handlePwaInstall()
      // }
    },
    handleBeforeInstallPrompt(e) {
      e.preventDefault()
      this.deferredPrompt = e
    },
    async handlePwaInstall() {
      if (this.shouldSkipPWAInstallCheck()) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Installation Unavailable',
          detail: 'The app is already installed',
          life: 4000,
        })

        return
      }

      if (!this.deferredPrompt) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Installation Unavailable',
          detail: 'Your browser does not support installing this app.',
          life: 4000,
        })

        return
      }

      await installPWA({
        deferredPrompt: this.deferredPrompt,
        onCleanup: () => {
          this.cleanup()
        }
      })
    },
    cleanup() {
      this.showPrompt = false
    },
    scrollToSelectorItem(wrap, aim) {
      this.closeFooterLandingMenu()
      this.scrollToSelector(
        wrap,
        aim,
        parseInt(this.headerHeight) + parseInt(this.reportBannerHeight),
      )
    },
    closeDropdown() {
      this.isOpen = false
    },
    logoutUser() {
      this.logout()
      window.location.assign('/')
    },
    contactSupport() {
      this.contactSatoshieyeSupport()
    },
    closeFooterLandingMenu() {
      this.SET_SHOW_LANDING_MENU(false)
    },
    openFooterLandingMenu() {
      this.SET_SHOW_LANDING_MENU(true)
    },
    onLookupClick() {
      if (this.isB2bUser) return
      this.$router.push({ name: 'payment' })
    },
    onPlanClick() {
      this.$router.push({ name: 'profile' })
    },
    onLimitClick() {
      const { monthlyQuota, reportsRemaining } = this.getCurrentPlan || {};
      const isValidQuota = monthlyQuota !== undefined && monthlyQuota >= 0;

      if (isValidQuota && reportsRemaining <= 0) {
        this.openModal({ component: LimitsReachedModal, props: { limitInfo: { reportsRemaining, monthlyQuota } } })
      }
    },
  },
}
</script>

<style>
.admin-mark {
  position: absolute;
  left: 95px;
}
.header__button-get-report {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding: 0 36px;
  border: 2px solid var(--reflex-bluet);
  border-radius: 4px;
  text-decoration: none;
  color: var(--reflex-bluet);
}
.footer-menu-landing-wrapper .header__button-get-report {
  margin: 0 16px 16px 16px;
}

.header__lookups {
  display: flex;
  align-items: center;
  gap: 8px;
}
.header__lookups .link {
  color: var(--reflex-bluet);
  font-weight: 500 ;
}
.header__lookups-nolink .link {
  cursor: default;
}
.p-avatar {
  background-color: var(--Neutral-200);
  border: 1px solid var(--Basic-200);
  cursor: pointer;
}
.p-avatar .p-avatar-text {
  padding-top: 2px;
  font-weight: 700;
  font-size: 16px;
  color: var(--Basic-700);
}

.report-header-wrapper {
  width: var(--full-width);
  height: 68px;
  background-color: var(--white);
  position: absolute;
  z-index: 100;
}
.report-header-wrapper .header-wrapper {
  background: var(--white) !important;
  transition: none !important;
  transition: opacity 0.3s ease !important;
}

@media (max-width: 799px) {
  .header-wrapper {
    min-height: 72px !important;
    border-bottom: 1px solid var(--Basic-100);
  }
}
</style>

<style scoped>
.header-chips-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: capitalize;
}

.header-wrapper-with-subscription-banner {
  flex-direction: column;
  align-items: center;
}
</style>

